import React, { useState, useEffect, useCallback } from 'react';
import moment from 'moment';
import DateInput from '../date-input';
import styles from './date-range.module.scss';

const DateRange = ({
  labelStart,
  labelEnd,
  valueStart,
  valueEnd,
  min,
  max,
  onChange = () => {},
}) => {
  const [minDate, setMinDate] = useState(null);
  const [maxDate, setMaxDate] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [change, setChange] = useState(false);

  useEffect(() => {
    if (min) {
      setMinDate(moment(min).startOf('date').toDate());
    }
    if (max) {
      setMaxDate(moment(max).endOf('date').toDate());
    }
    const start = moment(valueStart || moment().subtract(1, 'month').startOf('month').toDate()).startOf('date').toDate();
    const end = moment(valueEnd || moment().add(1, 'month').startOf('month').toDate()).endOf('date').toDate();
    setStartDate(start);
    setEndDate(end);
  }, [valueStart, valueEnd, min, max]);

  useEffect(() => {
    if (change && onChange) {
      onChange({
        startDate,
        endDate,
      });
    }

    setChange(false);
  }, [change, startDate, endDate, onChange]);

  const onChangeStart = useCallback((date) => {
    setStartDate(moment(date).startOf('date').toDate());
    setChange(true);
  }, []);

  const onChangeEnd = useCallback((date) => {
    setEndDate(moment(date).endOf('date').toDate());
    setChange(true);
  }, []);

  return (
    <div className={styles.date}>
      <div className={styles.item}>
        <DateInput
          selectsStart
          endDate={endDate}
          maxDate={endDate}
          minDate={minDate}
          label={labelStart}
          value={startDate}
          onChange={onChangeStart}
        />
      </div>
      <div className={styles.item}>
        <DateInput
          selectsEnd
          minDate={startDate}
          maxDate={maxDate}
          startDate={startDate}
          label={labelEnd}
          value={endDate}
          onChange={onChangeEnd}
        />
      </div>
    </div>
  );
};

export default DateRange;
